import React from 'react';
import { SearchIcon, MailIcon, DatabaseIcon, SendIcon } from 'lucide-react';
export function DataDirectoryValueProps() {
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-746">
      <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-100 p-8 md:p-12 lg:p-16" data-id="element-747">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-748">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 tracking-tight" data-id="element-749">
            Why teams choose our{' '}
            <span className="text-blue-600" data-id="element-750">local business database</span>
          </h2>
          <p className="text-lg text-slate-500" data-id="element-751">
            The most reliable source for local business listings and verified
            contact data.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-752">
          <div className="bg-slate-50 rounded-3xl p-8 border border-slate-100 hover:border-blue-100 hover:shadow-md transition-all" data-id="element-753">
            <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center text-blue-600 mb-6 shadow-sm border border-slate-100" data-id="element-754">
              <SearchIcon className="w-6 h-6" data-id="element-755" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3 tracking-tight" data-id="element-756">
              Local business owner finder
            </h3>
            <p className="text-slate-500 leading-relaxed" data-id="element-757">
              Find verified owners and decision-makers at local small
              businesses. Our local business owner finder gives you direct
              access to the people who make purchasing decisions.
            </p>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 border border-slate-100 hover:border-blue-100 hover:shadow-md transition-all" data-id="element-758">
            <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center text-blue-600 mb-6 shadow-sm border border-slate-100" data-id="element-759">
              <MailIcon className="w-6 h-6" data-id="element-760" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3 tracking-tight" data-id="element-761">
              Verified business owner emails
            </h3>
            <p className="text-slate-500 leading-relaxed" data-id="element-762">
              Every business owner email in our database is verified in
              real-time. Stop bouncing — reach local business owners with
              confidence.
            </p>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 border border-slate-100 hover:border-blue-100 hover:shadow-md transition-all" data-id="element-763">
            <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center text-blue-600 mb-6 shadow-sm border border-slate-100" data-id="element-764">
              <DatabaseIcon className="w-6 h-6" data-id="element-765" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3 tracking-tight" data-id="element-766">
              Comprehensive local business listings
            </h3>
            <p className="text-slate-500 leading-relaxed" data-id="element-767">
              Browse 300+ categories of local business listings with 50+ data
              points per business. The most complete local business database
              available.
            </p>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 border border-slate-100 hover:border-blue-100 hover:shadow-md transition-all" data-id="element-768">
            <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center text-blue-600 mb-6 shadow-sm border border-slate-100" data-id="element-769">
              <SendIcon className="w-6 h-6" data-id="element-770" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3 tracking-tight" data-id="element-771">
              Built-in email sequencing
            </h3>
            <p className="text-slate-500 leading-relaxed" data-id="element-772">
              Launch personalized email campaigns directly to local businesses
              from our platform. No CSV exports needed.
            </p>
          </div>
        </div>
      </div>
    </section>;
}